export default __webpack_public_path__ + "static/media/emptyLogo.f0762242.svg";